import http from "@/http-common";

const BASE = "statistics/attendance";

class AttendanceStatisticsService {
  getSummary(date) {
    return http.get(`${BASE}/summary`, { params: { date } });
  }

  getTrend(date, mode) {
    return http.get(`${BASE}/trend`, { params: { date, mode } });
  }

  getPendingAbsentRequests() {
    return http.get(`${BASE}/pending-absent-requests`);
  }

  getClasses(date) {
    return http.get(`${BASE}/classes`, { params: { date } });
  }
}

export default new AttendanceStatisticsService();
